module.exports = __webpack_public_path__ + "img/AXA_png.a24620ff.png";